import {BASE_URL} from 'shared/const';
import {actionMessage} from 'interactors/messageBus/create';
import {Emitter} from 'interactors/messageBus/Emitter';

type Dependencies = {
  location?: Location;
  emitter?: Emitter;
};

export function updateOrigin(amount: MoneyAmount, days: DaysCount, di: Dependencies = {}): void {
  const {emitter = Emitter, location = window.location} = di;
  if (location.href.includes(BASE_URL)) return;

  const payload = {amount, days};
  emitter.emit(actionMessage('update-base-url', payload));
}
